import * as Types from './userActionTypes.js'

const initialState = {
    userToken: '',
    userInfo: '',
    isAdministrator: false,
    isPloegchef: false,
    isExtrusieOperator: false,
    isSchrijnwerkOperator: false,
    isScrapOperator: false,
    isPercentageEditor: false,
    packer: ''
};

export default function user(state = initialState, action) {
    switch (action.type) {
        case Types.SET_PACKER:
            return state.packer !== action.packer ? { ...state, packer: action.packer } : state;

        case Types.SET_USERTOKEN:
            return state.userToken !== action.userToken ? { ...state, userToken: action.userToken } : state;

        case Types.SET_USERINFO:
            if (state.userInfo !== action.userInfo) {
                if(action.userInfo.role !== undefined && action.userInfo.role !== null){
                    state.isAdministrator = action.userInfo.role.includes("Administrator");
                    state.isPloegchef = action.userInfo.role.includes("Ploegchef");
                    state.isExtrusieOperator = action.userInfo.role.includes("Extrusie operator");
                    state.isSchrijnwerkOperator = action.userInfo.role.includes("Schrijnwerkerij operator");
                    state.isScrapOperator = action.userInfo.role.includes("Scrap operator");
                    state.isMasterOperator = action.userInfo.role.includes("Master operator");
                }     
                if(!state.isAdministrator && !state.isSchrijnwerkOperator && !state.isPloegchef && !state.isScrapOperator){
                    state.isExtrusieOperator = true;
                }

                return Object.assign({}, state, { userInfo: action.userInfo });
            }
            return state;
        default:
            return state;
    }
}